import { render } from "./CodeConfirmation.vue?vue&type=template&id=43472f82&ts=true"
import script from "./CodeConfirmation.vue?vue&type=script&lang=ts"
export * from "./CodeConfirmation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__